import {waitUntil} from '@aboutyou/utils';

let contentViewFired = false;

export const waitUntilContentView = () => {
  if (contentViewFired) {
    return {
      waiter: Promise.resolve(),
      cancel: () => undefined,
    };
  }

  const {waiter, cancel} = waitUntil(() => {
    /**
     * In test environment, window.dataLayer is not available and we dont want to wait for it be default because it would make simpler tests
     * checking for content view to be fired more complicated.
     */
    if (process.env.NODE_ENV === 'test') {
      return true;
    }
    const fired = window.dataLayer.some(
      (item: any) =>
        item.event === 'contentView' || item.event === 'content_view',
    );
    if (fired) {
      contentViewFired = true;
    }
    return contentViewFired;
  });

  return {
    waiter,
    cancel,
  };
};
